function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  y: 4.5,
  width: 15,
  height: 15,
  rx: 1.5,
  stroke: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.81191 11.1594C6.34247 11.1594 5.96191 11.5399 5.96191 12.0094C5.96191 12.4788 6.34247 12.8594 6.81191 12.8594L14.1153 12.8594L14.1153 14.1094C14.1153 14.5218 14.3662 14.8928 14.749 15.0462C15.1318 15.1997 15.5695 15.1049 15.8544 14.8067L17.7653 12.8067C18.1315 12.4234 18.1389 11.8221 17.7821 11.4301L15.8712 9.33007C15.5906 9.02171 15.1493 8.9176 14.7604 9.06803C14.3716 9.21846 14.1153 9.59248 14.1153 10.0094L14.1153 11.1594L6.81191 11.1594Z",
  fill: "#00BB77"
});
const SvgSupplierOfferingsAdd = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSupplierOfferingsAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/supplierOfferingsAdd.a72aab00.svg";
export { ForwardRef as ReactComponent };